export const HOME_PAGE_REQUEST = "HOME_PAGE_REQUEST"
export const HOME_PAGE_SUCCESS = "HOME_PAGE_SUCCESS"
export const HOME_PAGE_ERROR   = "HOME_PAGE_ERROR"

export const FIELD_POST_LIST_REQUEST = "FIELD_POST_LIST_REQUEST"
export const FIELD_POST_LIST_SUCCESS = "FIELD_POST_LIST_SUCCESS"
export const FIELD_POST_LIST_ERROR   = "FIELD_POST_LIST_ERROR"

export const SIGNUP_USER_REQUEST = "SIGNUP_USER_REQUEST"
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS"
export const SIGNUP_USER_ERROR   = "SIGNUP_USER_ERROR"

export const SIGNIN_USER_REQUEST = "SIGNIN_USER_REQUEST"
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS"
export const SIGNIN_USER_ERROR   = "SIGNIN_USER_ERROR"

export const  GET_PROFILE_REQUEST = "GET_PROFILE_REQUEST"  
export const  GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS"
export const  GET_PROFILE_ERROR   = "GET_PROFILE_ERROR"

export const  RESUME_FILE_POST_REQUEST = "RESUME_FILE_POST_REQUEST"  
export const  RESUME_FILE_POST_SUCCESS = "RESUME_FILE_POST_SUCCESS"
export const  RESUME_FILE_POST_ERROR   = "RESUME_FILE_POST_ERROR"

export const  UPDATE_PROFILE_REQUEST = "UPDATE_PROFILE_REQUEST"  
export const  UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const  UPDATE_PROFILE_ERROR   = "UPDATE_PROFILE_ERROR"

export const  RESUME_POST_TO_REQUEST = "RESUME_POST_TO_REQUEST"  
export const  RESUME_POST_TO_SUCCESS = "RESUME_POST_TO_SUCCESS"
export const  RESUME_POST_TO_ERROR   = "RESUME_POST_TO_ERROR"

export const  RESUME_LIST_REQUEST = "RESUME_LIST_REQUEST"  
export const  RESUME_LIST_SUCCESS = "RESUME_LIST_SUCCESS"
export const  RESUME_LIST_ERROR   = "RESUME_LIST_ERROR"

export const  RESUME_DELETE_REQUEST = "RESUME_DELETE_REQUEST"  
export const  RESUME_DELETE_SUCCESS = "RESUME_DELETE_SUCCESS"
export const  RESUME_DELETE_ERROR   = "RESUME_DELETE_ERROR"

export const  CONTACT_US_SEND_REQUEST ="CONTACT_US_SEND_REQUEST"
export const  CONTACT_US_SEND_SUCCESS ="CONTACT_US_SEND_SUCCESS"
export const  CONTACT_US_SEND_ERROR   ="CONTACT_US_SEND_ERROR"

export const  REQUEST_SET_BY_CITY      ="REQUEST_SET_BY_CITY"
export const  REQUEST_FIND_BY_CITY     ="REQUEST_FIND_BY_CITY"
export const  REQUEST_DENIED_BY_CITY   ="REQUEST_DENIED_BY_CITY"

export const  SPECIALZATION_ADD_TO_REQUEST   = "SPECIALZATION_ADD_TO_REQUEST"
export const  SPECIALZATION_ADD_TO_SUCCESS   = "SPECIALZATION_ADD_TO_SUCCESS"
export const  SPECIALZATION_ADD_TO_ERROR     = "SPECIALZATION_ADD_TO_ERROR"

export const  SPECIALZATION_LIST_REQUEST     = "SPECIALZATION_LIST_REQUEST"
export const  SPECIALZATION_LIST_SUCCESS     = "SPECIALZATION_LIST_SUCCESS"
export const  SPECIALZATION_LIST_ERROR       = "SPECIALZATION_LIST_ERROR"

export const  DASHBOARD_DATA_COUNT_REQUEST     = "DASHBOARD_DATA_COUNT_REQUEST"
export const  DASHBOARD_DATA_COUNT_SUCCESS     = "DASHBOARD_DATA_COUNT_SUCCESS"
export const  DASHBOARD_DATA_COUNT_ERROR       = "DASHBOARD_DATA_COUNT_ERROR"

export const  DASHBOARD_GRAPH_ANALYTICS_REQUEST     = "DASHBOARD_GRAPH_ANALYTICS_REQUEST"
export const  DASHBOARD_GRAPH_ANALYTICS_SUCCESS     = "DASHBOARD_GRAPH_ANALYTICS_SUCCESS"
export const  DASHBOARD_GRAPH_ANALYTICS_ERROR       = "DASHBOARD_GRAPH_ANALYTICS_ERROR"


export const  NOTIFICATION_LIST_REQUEST = "NOTIFICATION_LIST_REQUEST"
export const  NOTIFICATION_LIST_SUCCESS = "NOTIFICATION_LIST_SUCCESS"
export const  NOTIFICATION_LIST_ERROR   = "NOTIFICATION_LIST_ERROR"
 
export const  NOTIFICATION_UNREAD_LIST_REQUEST = "NOTIFICATION_UNREAD_LIST_REQUEST"
export const  NOTIFICATION_UNREAD_LIST_SUCCESS = "NOTIFICATION_UNREAD_LIST_SUCCESS"
export const  NOTIFICATION_UNREAD_LIST_ERROR   = "NOTIFICATION_UNREAD_LIST_ERROR"
 
export const  NOTIFICATION_STATUS_CHANGE_REQUEST ="NOTIFICATION_STATUS_CHANGE_REQUEST"
export const  NOTIFICATION_STATUS_CHANGE_SUCCESS ="NOTIFICATION_STATUS_CHANGE_SUCCESS"
export const  NOTIFICATION_STATUS_CHANGE_ERROR   ="NOTIFICATION_STATUS_CHANGE_ERROR"

export const  GET_CITY_BY_COUNTRY_LIST_REQUEST ="GET_CITY_BY_COUNTRY_LIST_REQUEST"
export const  GET_CITY_BY_COUNTRY_LIST_SUCCESS ="GET_CITY_BY_COUNTRY_LIST_SUCCESS"
export const  GET_CITY_BY_COUNTRY_LIST_ERROR   ="GET_CITY_BY_COUNTRY_LIST_ERROR"

export const  GET_COUNTRY_LIST_REQUEST ="GET_COUNTRY_LIST_REQUEST"
export const  GET_COUNTRY_LIST_SUCCESS ="GET_COUNTRY_LIST_SUCCESS"
export const  GET_COUNTRY_LIST_ERROR   ="GET_COUNTRY_LIST_ERROR"

export const  GET_ALL_CITY_LIST_REQUEST ="GET_ALL_CITY_LIST_REQUEST"
export const  GET_ALL_CITY_LIST_SUCCESS ="GET_ALL_CITY_LIST_SUCCESS"
export const  GET_ALL_CITY_LIST_ERROR   ="GET_ALL_CITY_LIST_ERROR"

export const  UNREAD_CHAT_REQUEST = "UNREAD_CHAT_REQUEST"
export const  UNREAD_CHAT_SUCCESS = "UNREAD_CHAT_SUCCESS"
export const  UNREAD_CHAT_ERROR   = "UNREAD_CHAT_ERROR"

export const  READ_CHAT_REQUEST = "READ_CHAT_REQUEST"
export const  READ_CHAT_SUCCESS = "READ_CHAT_SUCCESS"
export const  READ_CHAT_ERROR   = "READ_CHAT_ERROR"

export const  CHAT_USER_LIST_REQUEST = "CHAT_USER_LIST_REQUEST"
export const  CHAT_USER_LIST_SUCCESS = "CHAT_USER_LIST_SUCCESS"
export const  CHAT_USER_LIST_ERROR   = "CHAT_USER_LIST_ERROR"

export const  CHAT_USER_LIST_SEARCH_REQUEST = "CHAT_USER_LIST_SEARCH_REQUEST"
export const  CHAT_USER_LIST_SEARCH_SUCCESS = "CHAT_USER_LIST_SEARCH_SUCCESS"
export const  CHAT_USER_LIST_SEARCH_ERROR   = "CHAT_USER_LIST_SEARCH_ERROR"

export const  GET_COMPANY_CHAT_REQUEST = "GET_COMPANY_CHAT_REQUEST"
export const  GET_COMPANY_CHAT_SUCCESS = "GET_COMPANY_CHAT_SUCCESS"
export const  GET_COMPANY_CHAT_ERROR   = "GET_COMPANY_CHAT_ERROR"

export const  BLOCK_USER_CHAT_REQUEST = "BLOCK_USER_CHAT_REQUEST"
export const  BLOCK_USER_CHAT_SUCCESS = "BLOCK_USER_CHAT_SUCCESS"
export const  BLOCK_USER_CHAT_ERROR   = "BLOCK_USER_CHAT_ERROR"

export const  UNBLOCK_USER_CHAT_REQUEST = "UNBLOCK_USER_CHAT_REQUEST"
export const  UNBLOCK_USER_CHAT_SUCCESS = "UNBLOCK_USER_CHAT_SUCCESS"
export const  UNBLOCK_USER_CHAT_ERROR   = "UNBLOCK_USER_CHAT_ERROR"

export const  FORWARD_CHAT_REQUEST  = "FORWARD_CHAT_REQUEST"
export const  FORWARD_CHAT_SUCCESS  = "FORWARD_CHAT_SUCCESS"
export const  FORWARD_CHAT_ERROR    = "FORWARD_CHAT_ERROR"

export const GET_LIST_CHAT_REQUEST = "GET_LIST_CHAT_REQUEST"
export const GET_LIST_CHAT_SUCCESS = "GET_LIST_CHAT_SUCCESS"
export const GET_LIST_CHAT_ERROR   = "GET_LIST_CHAT_ERROR"

export const DEACTIVATE_ACCOUNT_REQUEST = "DEACTIVATE_ACCOUNT_REQUEST"
export const DEACTIVATE_ACCOUNT_SUCCESS = "DEACTIVATE_ACCOUNT_SUCCESS"
export const DEACTIVATE_ACCOUNT_ERROR   = "DEACTIVATE_ACCOUNT_ERROR"

export const ADD_JOB_REQUEST = "ADD_JOB_REQUEST"
export const ADD_JOB_SUCCESS = "ADD_JOB_SUCCESS"
export const ADD_JOB_ERROR   = "ADD_JOB_ERROR"

export const UPDATE_JOB_REQUEST = "UPDATE_JOB_REQUEST"
export const UPDATE_JOB_SUCCESS = "UPDATE_JOB_SUCCESS"
export const UPDATE_JOB_ERROR   = "UPDATE_JOB_ERROR"

export const JOBLIST_PROVIDER_REQUEST = "JOBLIST_PROVIDER_REQUEST"
export const JOBLIST_PROVIDER_SUCCESS = "JOBLIST_PROVIDER_SUCCESS"
export const JOBLIST_PROVIDER_ERROR   = "JOBLIST_PROVIDER_ERROR"

export const JOB_LIST_USER_REQUEST = "JOB_LIST_USER_REQUEST"
export const JOB_LIST_USER_SUCCESS = "JOB_LIST_USER_SUCCESS"
export const JOB_LIST_USER_ERROR   = "JOB_LIST_USER_ERROR"

export const JOB_STATUS_REQUEST = "JOB_STATUS_REQUEST"
export const JOB_STATUS_SUCCESS = "JOB_STATUS_SUCCESS"
export const JOB_STATUS_ERROR   = "JOB_STATUS_ERROR"

export const ADD_SUBUSER_REQUEST = "ADD_SUBUSER_REQUEST"
export const ADD_SUBUSER_SUCCESS = "ADD_SUBUSER_SUCCESS"
export const ADD_SUBUSER_ERROR   = "ADD_SUBUSER_ERROR"

export const SUBUSER_LIST_REQUEST = "SUBUSER_LIST_REQUEST"
export const SUBUSER_LIST_SUCCESS = "SUBUSER_LIST_SUCCESS"
export const SUBUSER_LIST_ERROR   = "SUBUSER_LIST_ERROR"

export const SUBUSER_STATUS_REQUEST = "SUBUSER_STATUS_REQUEST"
export const SUBUSER_STATUS_SUCCESS = "SUBUSER_STATUS_SUCCESS"
export const SUBUSER_STATUS_ERROR   = "SUBUSER_STATUS_ERROR"

export const SIGNUP_SUB_USER_REQUEST = "SIGNUP_SUB_USER_REQUEST"
export const SIGNUP_SUB_USER_SUCCESS = "SIGNUP_SUB_USER_SUCCESS"
export const SIGNUP_SUB_USER_ERROR   = "SIGNUP_SUB_USER_ERROR"

export const GET_IN_TOUCH_USER_REQUEST = "GET_IN_TOUCH_USER_REQUEST"
export const GET_IN_TOUCH_USER_SUCCESS = "GET_IN_TOUCH_USER_SUCCESS"
export const GET_IN_TOUCH_USER_ERROR   = "GET_IN_TOUCH_USER_ERROR"
	
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST"
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS"
export const FORGOT_PASSWORD_ERROR   = "FORGOT_PASSWORD_ERROR"

export const OTP_MATCH_USER_REQUEST = "OTP_MATCH_USER_REQUEST"
export const OTP_MATCH_USER_SUCCESS = "OTP_MATCH_USER_SUCCESS"
export const OTP_MATCH_USER_ERROR   = "OTP_MATCH_USER_ERROR"

export const FORGOT_PASSWORD_UPDATE_REQUEST = "FORGOT_PASSWORD_UPDATE_REQUEST"
export const FORGOT_PASSWORD_UPDATE_SUCCESS = "FORGOT_PASSWORD_UPDATE_SUCCESS"
export const FORGOT_PASSWORD_UPDATE_ERROR   = "FORGOT_PASSWORD_UPDATE_ERROR"

export const JOB_EDIT_DATA_SET_REQUEST   = "JOB_EDIT_DATA_SET_REQUEST"

export const USER_BLOG_REQUEST   = "USER_BLOG_REQUEST"
export const USER_BLOG_SUCCESS   = "USER_BLOG_SUCCESS"
export const USER_BLOG_ERROR   = "USER_BLOG_ERROR"

export const USER_RECRUITER_VIEW_REQUEST   = "USER_RECRUITER_VIEW_REQUEST"
export const USER_RECRUITER_VIEW_SUCCESS   = "USER_RECRUITER_VIEW_SUCCESS"
export const USER_RECRUITER_VIEW_ERROR   = "USER_RECRUITER_VIEW_ERROR"

export const CHECKUSER_URL_REQUEST   = "CHECKUSER_URL_REQUEST"
export const CHECKUSER_URL_SUCCESS   = "CHECKUSER_URL_SUCCESS"
export const CHECKUSER_URL_ERROR   = "CHECKUSER_URL_ERROR"

export const UPDATEUSER_URL_REQUEST   = "UPDATEUSER_URL_REQUEST"
export const UPDATEUSER_URL_SUCCESS   = "UPDATEUSER_URL_SUCCESS"
export const UPDATEUSER_URL_ERROR   = "UPDATEUSER_URL_ERROR"

export  const JOB_VIEW_STATUS_REQUEST = "JOB_VIEW_STATUS_REQUEST" 
export  const JOB_VIEW_STATUS_SUCCESS = "JOB_VIEW_STATUS_SUCCESS" 
export  const JOB_VIEW_STATUS_ERROR = "JOB_VIEW_STATUS_ERROR" 




// WEBPACK FOOTER //
// ./src/actions/actionTypes.js